import axios from "axios";

export const business = {
  namespaced: true,
  state: () => ({
    services: null,
    districtsMap: null
  }),
  mutations: {
    SET_BUSINESS(state, { services, districtsMap }) {
      state.services = services;
      state.districtsMap = districtsMap;
    }
  },
  actions: {
    async load({ commit }) {
      const { data } = await axios.get(
        process.env.VUE_APP_NIREX_API_URL + "/business"
      );
      commit("SET_BUSINESS", data);
    }
  },
  getters: {
    districts: state => {
      return Object.values(state.districtsMap);
    }
  }
};
